
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/devoluciones",
      function () {
        return require("private-next-pages/devoluciones/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/devoluciones"])
      });
    }
  